'use strict';

import {gsap} from 'gsap';
import {CustomEase} from 'gsap/CustomEase';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const statistics = document.querySelectorAll('.block.statistics');

if (window.screen.width >= 768) {

    gsap.set('.statistics-card h2', {y: '100%'});
    gsap.set('.statistics-card .card-border', {width: 0});
    gsap.set('.statistics-card .card-name', {opacity: 0});
    gsap.set('.statistics-card img', {scale: 0});
    statistics.forEach((statistic) => {
        ScrollTrigger.create({
            trigger: statistic,
            start: "top center",
            end: "bottom center",
            scrub: 1,
            once: true,
            onEnter: (self) => {
                const trigger = self.trigger;
                const borders = trigger.querySelectorAll('.card-border');
                const icons = trigger.querySelectorAll('img');
                const values = trigger.querySelectorAll('h2');
                const names = trigger.querySelectorAll('.card-name');

                gsap.to(borders, {width: '100%', duration: 1});
                gsap.to(names, {opacity: 1, width: '100%', duration: 1});
                gsap.to(icons, {scale: 1, delay: 1, duration: 0.5});
                gsap.to(values, {y: 0, delay: 1, duration: 0.5});
            }
        });
    });
} else {
    const ease = CustomEase.create("custom", "M0,0 C0.083,0.294 0.146,0.784 0.412,0.974 0.543,1.067 0.752,1 1,1 ");
    let timeline = gsap.timeline({repeat: -1});
    gsap.set('.statistics-card', {opacity: 0});
    let cardHeightPx = 160;

    statistics.forEach((statistic) => {
        const cards = statistic.querySelectorAll('.statistics-card');
        const listing = statistic.querySelector('.listing-wrap');

        let i = 0;

        cards.forEach((card, index) => {

            cardHeightPx = card.offsetHeight > cardHeightPx ? card.offsetHeight : cardHeightPx;

            const visibleSeconds = parseInt(card.getAttribute('data-speed'));
            const cardTop = card.querySelectorAll('.card-top');
            const cardBorder = card.querySelectorAll('.card-border-wrap');
            const cardName = card.querySelectorAll('.card-name');

            timeline.to(card, {opacity: 1}, i);
            timeline.fromTo(cardTop, {x: '-100vw'}, {x: 0, ease: ease}, i);
            i += 1;
            timeline.fromTo(cardBorder, {x: '-100vw'}, {x: 0, ease: ease}, i);
            timeline.fromTo(cardName, {x: '-100vw'}, {x: 0, ease: ease}, i);

            i += visibleSeconds;
            timeline.to(cardTop, {x: '-100vw'}, i);
            timeline.to(cardBorder, {x: '-100vw'}, i);
            timeline.to(cardName, {x: '100vw'}, i);
            timeline.to(card, {opacity: 0}, i);
            i += 1;
        });

        cards.forEach((card) => {
            card.parentNode.style.height = cardHeightPx + 'px';
        });

        listing.style.height = cardHeightPx + 'px';

    });
}
